<template>    
    <v-dialog v-model="open" width="600">
      <v-card >
        <v-card-title class="headline">Existen problemas al generar la EMI.<br><small>Por favor revise a continuación</small></v-card-title>
        <v-card-text>
            <v-list class="app-card-action">
                <v-list-tile 
                    v-for="(msg, index) in messages"
                    :key="index"
                >
                    <i class="zmdi zmdi-fullscreen primary--text mr-2 fs-14"></i>
                    <span>{{msg}}</span>
                </v-list-tile>                
            </v-list>
            <v-layout row wrap>           
        </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>    
</template>
<script>

import Vue from "vue";

export default {
  components: {
    
  },
  computed: {

  },
  methods: {
    show(messages){
        this.open = true;
        this.messages = messages;        
    }
  },
  data() {
    return {
        open: false,
        messages: [
            "Unidad Comercial asignada: Unidad 1, Unidad BPM: 1",
            "Regla Aplicada: CP QUITO",
            "Ejecutivo Comercial asignado: Nombres: MOLINA ATI MAURO DANIEL, Email: mauro.molina@asur.ec",
            "No requiere revisión de cartera",
            "Consulta información de Sisprev, Identificación: 1768181900001, Nombres: . ., Es Observado: False, EsPep: False",
            "No requiere Inspección",
            "Orden de Emisión creada en BPM. EMI-235029",
            "Información grabada correctamente en base de datos"
        ]
    }
  }
}

</script>